/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_File_Exists_TitleInputs */



/**
* | output |
* | --- |
* | "File Already Exists" |
*
* @param {Video_Export_File_Exists_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_file_exists_title = /** @type {((inputs?: Video_Export_File_Exists_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_File_Exists_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le fichier existe deja")
	if (locale === "de") return /** @type {LocalizedString} */ ("Datei existiert bereits")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il file esiste gia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Файл уже существует")
	if (locale === "es") return /** @type {LocalizedString} */ ("El archivo ya existe")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件已存在")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイルは既に存在します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ाइल पहले से मौजूद है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O ficheiro ja existe")
	return /** @type {LocalizedString} */ ("File Already Exists")
});